import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Activate() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const nav = useNavigate();
  const { setCtx } = useAuth();
  const [state, setState] = useState({ loading: true, valid: false, email: "", plan: "" });
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/api/billing/activate/${token}`);
        setState({ loading: false, valid: true, email: data.email, plan: data.plan });
      } catch {
        setState({ loading: false, valid: false });
      }
    })();
  }, [token]);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/api/billing/activate", { token, password: pw });
      setCtx(data);
      toast.success("Compte activé");
      nav(data.user?.onboarded ? "/" : "/onboarding", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  if (state.loading) return <div className="flex h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F2F4F7] p-6" data-testid="activate-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        {!state.valid ? (
          <div className="text-center">
            <h1 className="text-xl font-bold text-slate-900">Lien invalide ou expiré</h1>
            <p className="mt-2 text-sm text-slate-500">Ce lien d'activation n'est plus valide. Contactez le support ActiPilote.</p>
          </div>
        ) : (
          <>
            <h1 className="text-xl font-bold text-slate-900">Activez votre compte ActiPilote</h1>
            <p className="mt-1 text-sm text-slate-500">Offre {state.plan?.toUpperCase()} · {state.email}</p>
            <label className="mt-6 block text-xs font-medium text-slate-500">Choisissez un mot de passe</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="activate-password-input"
              className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20" placeholder="8 caractères minimum" />
            <button onClick={submit} disabled={busy || pw.length < 8} data-testid="activate-submit-button"
              className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Activer mon compte
            </button>
          </>
        )}
      </div>
    </div>
  );
}
